import { useMutation } from '@tanstack/vue-query';

import mutationLogout from '../api/mutationLogout';

import useCookie from '@/composables/useCookie';
import { COOKIE_KEY } from '@/constant';

import type { UseMutationOptions } from '@tanstack/vue-query';

export default (
  options?: UseMutationOptions<
    AwaitedReturn<typeof mutationLogout>,
    any,
    undefined,
    unknown
  >
) => {
  const token = useCookie<string | null>(COOKIE_KEY.TOKEN, { watch: true });
  const accessToken = useCookie<string | null>(COOKIE_KEY.ACCESS_TOKEN, {
    watch: true,
  });
  const refreshToken = useCookie<string | null>(COOKIE_KEY.REFRESH_TOKEN, {
    watch: true,
  });

  const refreshExpired = useCookie<string | null>(COOKIE_KEY.REFRESH_EXPIRED, {
    watch: true,
  });

  const mutationFn = async () => {
    if (!token.value) return true;
    return await mutationLogout({
      code: token.value,
    });
  };

  return useMutation({
    ...options,
    mutationFn,
    onSuccess(...rest) {
      token.value = null;
      accessToken.value = null;
      refreshToken.value = null;
      refreshExpired.value = null;
      options?.onSuccess?.(...rest);
    },
  });
};
